import { BaseModel } from '../base/base.model';

/**
 * A class to store an error report
 */
export class ClientErrorReport extends BaseModel {
  /**
   * @param serviceName - The name of the service reporting the error
   * @param message - The error message
   * @param status - The error status
   * @param statusText - The status text
   * @param url - The offending URL
   * @param stackTrace - A stack trace
   */
  constructor(
    public serviceName: string,
    public message: string,
    public status: number,
    public statusText: string,
    public url: string,
    public stackTrace?: string
  ) {
    super();
  }
}
